import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function BottomSheet({
  open,
  onClose,
  title,
  children,
  maxHeight = '80vh'
}: {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  maxHeight?: string;
}) {
  return <AnimatePresence data-id="element-55">
      {open && <>
          <motion.div className="fixed inset-0 bg-black/40 z-50" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} data-id="element-56" />
          <motion.div className="fixed bottom-0 left-1/2 w-full max-w-[390px] bg-white rounded-t-2xl z-50 flex flex-col" style={{
        maxHeight
      }} initial={{
        y: '100%',
        x: '-50%'
      }} animate={{
        y: 0,
        x: '-50%'
      }} exit={{
        y: '100%',
        x: '-50%'
      }} transition={{
        type: 'spring',
        damping: 30,
        stiffness: 300
      }} data-id="element-57">
            <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100" data-id="element-58">
              <div className="font-bold text-slate-800" data-id="element-59">{title}</div>
              <button onClick={onClose} aria-label="关闭" data-id="element-60">
                <XIcon size={20} className="text-slate-500" data-id="element-61" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto" data-id="element-62">{children}</div>
          </motion.div>
        </>}
    </AnimatePresence>;
}